export default __webpack_public_path__ + "static/media/playStore1.3779e0c2.png";